// Quotation Rejected Stage  Btn related codes goes here

// NPM Imports
import React, { Component, Fragment } from "react";

// Components Imports
// import { Button } from "../../../commonComponents";
import ExportDocumentBtn from "../../QuotationTopbar/QuotationTopbarBtns/ExportDocumentBtn";
// import QuotationSignerBottomBanner from "../../QuotationTopbar/QuotationBottomBar/QuotationSignerBottomBanner";

class QuotationSentSignOthers extends Component {
  state = {};

  render() {
    return (
      <Fragment>
        <div className="other-signer-buttons">
          {/* <QuotationSignerBottomBanner {...this.props} /> */}
        </div>
        {/* <Button
          className="analyse-document"
          isLoading={this.props.showBtnLoader}
          onClick={() => this.props.togglePopUp("acceptAndSign")}
          id={"EditBtnWithRbac".replace(/ +/g, "-").toLowerCase()}
          data-test="quotationTopbar-upgrade-stage-btn">
          Accept & eSign
        </Button> */}
        <ExportDocumentBtn docStatus={this.props.docStatus} />
      </Fragment>
    );
  }
}

export default QuotationSentSignOthers;



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationTopBarBtns/QuotationSentSignOthers.js